import { render } from "./BrueckeInfo.vue?vue&type=template&id=78359640"
import script from "./BrueckeInfo.vue?vue&type=script&lang=js"
export * from "./BrueckeInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__